// Names are always shown with a capital first letter: "ayaz" -> "Ayaz", "anne-marie o'brien" -> "Anne-Marie O'Brien".
// A word that already has a capital in it is left as typed apart from its first letter ("McDonald" stays "McDonald", "DeAndre" stays "DeAndre").
export function capitalizeName(value) {
  const text = String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  if (!text) return '';
  return text.split(' ').map((word) => {
    if (/[A-Z]/.test(word.slice(1)) || /[A-Z]/.test(word)) return word.charAt(0).toUpperCase() + word.slice(1);
    return word.replace(/(^|[-'’])([a-z])/g, (m, sep, ch) => sep + ch.toUpperCase());
  }).join(' ');
}
